"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Encounter_Location = exports.Encounter_LocationStatusKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Period_1 = require("./RTTI_Period");
var Encounter_LocationStatusKind;
(function (Encounter_LocationStatusKind) {
    Encounter_LocationStatusKind["_planned"] = "planned";
    Encounter_LocationStatusKind["_active"] = "active";
    Encounter_LocationStatusKind["_reserved"] = "reserved";
    Encounter_LocationStatusKind["_completed"] = "completed";
})(Encounter_LocationStatusKind = exports.Encounter_LocationStatusKind || (exports.Encounter_LocationStatusKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_Encounter_Location = t.recursion('IEncounter_Location', function () {
    return t.intersection([
        t.type({
            location: RTTI_Reference_1.RTTI_Reference
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            status: (0, EnumType_1.createEnumType)(Encounter_LocationStatusKind, 'Encounter_LocationStatusKind'),
            _status: RTTI_Element_1.RTTI_Element,
            physicalType: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            period: RTTI_Period_1.RTTI_Period
        })
    ]);
});
//# sourceMappingURL=RTTI_Encounter_Location.js.map